import React from 'react'
import { ScrollView } from 'react-native'

import { useRoute } from '@react-navigation/native'
import { H5, IconButton, SH2, Stack, XStack, colors } from '@zet/design-system'

const TermsOfUse = ({ navigation }) => {
  const { params } = useRoute()
  const navigateToCrif = () => {
    navigation.navigate('CrifTermsOfUse')
  }

  const navigateToExperian = () => {
    navigation.navigate('ExperianTermsOfUse')
  }

  return (
    <Stack className='flex-1 bg-white'>
      <XStack className="border-grays-40 justify-between border-b bg-white p-3">
        <XStack className="items-center justify-center">
          <IconButton
            type={'Close'}
            color={colors.grays[80]}
            onPress={navigation.goBack}
          />
          <H5 className="ml-2">Terms of Use</H5>
        </XStack>
      </XStack>
      <ScrollView contentContainerStyle={{ padding: 20 }} className="bg-white">
        <SH2 style={{ textAlign: 'justify' }}>
          {`
1. INTRODUCTION

1.1. THIS DOCUMENT IS AN ELECTRONIC RECORD IN TERMS OF THE INFORMATION
TECHNOLOGY ACT, 2000 AND RULES MADE THEREUNDER. THIS ELECTRONIC RECORD
IS GENERATED BY A COMPUTER SYSTEM AND DOES NOT REQUIRE ANY PHYSICAL OR
DIGITAL SIGNATURES.

1.2. THIS DOCUMENT IS PUBLISHED IN ACCORDANCE WITH THE PROVISIONS OF RULE 3(1)
OF THE INFORMATION TECHNOLOGY (INTERMEDIARY GUIDELINES AND DIGITAL MEDIA
ETHICS   CODE)  RULES,   2021   THAT   REQUIRES   PUBLISHING   THE   RULES   AND
REGULATIONS, PRIVACY POLICY AND USER AGREEMENT FOR ACCESS OR USAGE OF
THE APP.

1.3. The domain name myteams.co.in and the associated  mobile application titled ‘My Teams’ along
with   all   upgrades,   updates,   enhancement   and   modifications   thereto   (hereinafter   referred   to   as
“App”) is owned and managed Vistas Technolabs Private Limited, a company incorporated under
the provisions of the Companies Act, 2013 and having its registered office at 1105, Rawal Ji Ka
Bazar, Near Hotel Sun City, Ganga Pol, Jaipur, Rajasthan- 302002 (hereinafter referred to as
“Vistas” or “We” or “Us” which expression shall, unless it be repugnant to the context or meaning
thereof, be deemed to mean and include its successors, affiliates, and permitted assigns). 

1.4. Please read this End User License Agreement (“EULA”) carefully, as it contains the terms and
conditions   governing   your   use   of   the   App   and   any   content   such   as   text,   data,   information,
software, graphics, audio, video, or photographs etc. that Vistas may make available through the
App and any Services that Vistas may provide through the App. In order to use the App, you must
first agree to this EULA. By accessing, browsing, or using the App or otherwise clicking to accept
this EULA, if and when prompted on the App, you are agreeing to this EULA and concluding a
legally binding contract with Vistas. Please do not access or use the App or otherwise click to
accept this EULA, if and when prompted on the App, if you do not agree with any of the terms
provided below or are unable to be bound by them. As a condition of your access to and use of
the   App,   you   hereby   agree   that   you   will   comply   with   this   EULA   and   all   applicable   laws   and
regulations when using the App.

1.5. Vistas reserves the right, at its sole discretion, to change, modify, add, or remove portions of this
EULA, at any time and will notify you at least once in a year, or whenever there is a change in the
EULA, by email or by posting a conspicuous notice on the App. Your continued use of the App
following   the   posting   of   changes   shall   be   deemed   to   mean   that   you   accept   and   agree   to   the
revisions made to the EULA. As long as you comply with this EULA, Vistas grants you a personal,
revocable, non-exclusive, non-transferable, and limited privilege to access and use the App.

1.6. You should read the EULA and access and read all further linked information, if any, referred to in
the EULA, as such information contains further terms and conditions that apply to you as a user of the App. Such linked information including but not limited to the privacy policy (“Policy”) is
hereby incorporated by reference into this EULA. 

1.7. If you are unwilling or unable to be legally bound by this EULA, please do not use the App or
otherwise click to accept this EULA, if and when prompted on the App. You cannot accept this
EULA if: (a) you are not lawfully entitled to use the App; or (b) if you are not of legal age to form a
binding agreement with Vistas. 

2. DEFINITIONS 

2.1. In  this  EULA,  unless  the  context  or  meaning  otherwise  requires:  (a)  all  capitalised  words  and
expressions defined by inclusion in quotation and/or parenthesis anywhere in this EULA, have the
same meanings as ascribed to such words and expressions; and (b) the following terms shall
have the meaning ascribed to them hereunder. 

(A) “Applicable laws” shall mean means any applicable national, state, local or other law,
statute, regulations, rules, by laws, ordinances, principles of common law and includes
notifications, guidelines, policies, directions, directives, judgment, decree and orders of
any   Authority,   statutory   authority,   court,   tribunal,   or   recognized   stock   exchange,   and
having the force of law.

(B) “Partners” shall mean the third party entities that enter into agreements with Vistas for
hosting and/or marketing their financial products on the App for the benefit of the End
Users. 

(c) “Partner Products”   shall   mean   the   financial   products   and/or   services   offered   by   the
Partners for the benefit of the End Users marketed on the App. 

(d) “End User”   shall   mean   the   individuals   in   your   personal   contacts   that   you   market   the
Partner Products in accordance with the terms of this EULA. 

(e) “End User Information” shall be the information collected by you from the End User on
behalf of Vistas and/or the Partner for the facilitation of the End User’s availing of the
Partner Products which may or may not include Personal Information. 

(f) “Personal Information”   shall   mean   any   information   that   may   be   used   to   identify   an
individual, including, but not limited to, the first and last names, telephone number, e-mail
address, photograph, or any other contact information, income details, and educational
qualifications.   Further,   Sensitive   Personal   Data   or   Information   (“SPDI”)   of   a   person
includes   Personal   Information   about   that   person   relating   to:   passwords,   financial
information   (bank   accounts,   credit   and   debit   cards   or   other   payment   instruments),
physical information. Vistas limits the collection of Personal Information (including SPDI)
to that which is necessary for its intended purpose.

3. MEMBERSHIP ELIGIBILITY

Use of the App is available only to natural persons resident in India who can enter into legally
binding contracts under the Indian Contract Act, 1872. Persons who are “incompetent to contract”
within the meaning of the Indian Contract Act, 1872 including minors, un-discharged insolvents
and persons of unsound mind are not eligible to use the App. Any person under the age of 18
shall not register on App and shall not transact on or use the App. If a minor wishes to use or
transact   on   the   App,   such   use   or   transaction   may   be   made   by   the   minor’s   legal   guardian   or
parents   on   the   App.   Vistas   reserves   the   right   to   terminate   any   person’s   membership   in
accordance with the terms of this EULA and/or refuse to provide such person with access to the
App if it is brought to the notice of Vistas or if Vistas discovers for itself that such person is not
eligible to use the App. 

4. ACCEPTANCE OF EULA

4.1. In order to use the App, you must first agree to this EULA. You can accept the EULA by:

(g) Signing up with Vistas and logging onto Vistas by using the Login Credentials (defined
below); 

(h) Actual usage of the App. In this case, you understand and agree that Vistas will treat your
use of the App as acceptance of the EULA from that point onwards; or

(i) By clicking to accept this EULA, if and when prompted on the App.

5. OPENING AN ACCOUNT

5.1. In order to use the App, you will have to create an account by signing up on the App (“Account”),
which   can   be   done   by   providing/using   the   following:   (a)   your   mobile   number   with   One   Time
Password (OTP); or (b) such other login credentials that are adopted by Vistas from time to time
and   duly   intimated   to   you,   for   setting   up   an   Account   on   the   App.   Upon   entering   the   required
details, you may either receive a One Time Password (OTP) for the purpose of verification of your
Account   or   your   Account   may   be   verified   by   such   other   auto   verification   process   adopted   by
Vistas   from   time   to   time   and   duly   intimated   to   you,   and   upon   completion   of   verification,   the
Account is created and is ready for use. 

5.2. At the time of signing up, you will also be required to provide (a) an image of yourself; (b) official
identifiers like PAN and Aadhar Card; (c) bank account details; and (d) such other details as may
be required by Vistas and duly intimated to you.

5.3. While signing-up on the App, you shall not:

(a) create an Account for anyone other than yourself, unless such person's prior permission
has been obtained; or

(b) use an Account that is the name of another person with the intent to impersonate that
person.

5.4. Vistas cannot and will not be liable for any loss or damage arising from your failure to comply with
this provision.

6. USERNAME AND PASSWORD

6.1. Once registered, in order to log into the Account on the App, you will be required to provide the
following: (a) the mobile number used at the time of signing-up and One Time Password (OTP);
or (b) such other login credentials that are adopted by Vistas from time to time and duly intimated
to you for logging into the Account on the App (“Login Credentials”). 

6.2. You shall be solely responsible for maintaining confidentiality of the Login Credentials, and to the
extent   allowed   by   law,   you   hereby  accept  responsibility   for   all   activities   on   the   Account
authenticated through the Login Credentials, whether authorized or not. You agree to keep Login
Credentials confidential and secure, and you shall not give or make Login Credentials available,
directly or indirectly, to any unauthorized individual. You acknowledge and agree that if you allow,
whether   through   action   or   inaction,   a   person   to   gain   access   to   the   Login   Credentials,   with   or
without permission, you are authorizing that person to use the App through the Account, and you
shall be responsible for all actions that result from such access, even if you did not want the
actions performed, and even if they are unauthorized or fraudulent. Vistas shall not be held liable
in any manner whatsoever for lack of any such authorization whilst creating the Account.

6.3. Vistas cannot and will not be liable for any loss or damage arising from or arising out of your use
of the App, theft of the Login Credentials, use of the Login Credentials or release of the Login
Credentials to a third party or your authorization to allow another person to access and use the
App using the Account.

6.4. In case of any misappropriation   or   unauthorized   access   of   the   Account,   you   agree   to
communicate the same to Vistas immediately, in a manner indicated by Vistas. You shall further
ensure that you exit/logout from the Account at the end of each session. Vistas shall not be liable
for any loss or damage arising from your failure to comply with this provision. You may be held
liable for any losses incurred by Vistas or any other user of or visitor to the App due to authorized
or unauthorized use of the Account, as a result of your failure in keeping the Login Credentials
confidential.

6.5. You   agree   that   the   Information   provided   by   you   to   Vistas,   at   all   times   (including   during
registration), will be true, accurate, up-to-date, and complete. You further agree that if you provide
any   Information   that   is   untrue,   inaccurate,   not   up-to-date   or   incomplete   or   becomes   untrue,
inaccurate or incomplete or if Vistas has reasonable grounds to suspect that such information is
untrue, inaccurate, not up-to-date, incomplete or not in accordance with this EULA, Vistas shall
have the right to indefinitely suspend or terminate or block access to the Account on the App and
refuse to provide you access to the App. You are advised to use due caution when providing any
information to Vistas accordingly.

7. SERVICES 

7.1. Vistas provides a number of services through the App including (a) facilitation of signing up for
Partner   Products   by   the   End   Users   upon   your   (“My Teams user(s)”)   recommendation;   (b)
recommending Partner Products to the End Users based on the information provided by them;
and (c) providing such other services as may be made available on the App from time to time
(“Services”). Vistas is not and will not be responsible for any claim or for any damages suffered
that are related, directly or indirectly, to or arising out of your use of any Service on or through the
App.

7.2. As part of the Services, the My Teams users, shall be given access to the details of the Partner
Products that Vistas is associated with. You shall be responsible for sharing the details of the
Partner Products with End Users. Upon successful signing up of the End User for the Partner
Product,   you   shall   be   eligible   to   receive   My   Teams   user   Fee   (defined   below),   in   the   manner
determined by Vistas. Further, notwithstanding the fact that an End User is added to the App by
any particular My Teams user, My Teams user shall not have exclusive rights over the End Users
or   from   the   income   generated   through   the   End   Users   and   cannot   restrict   or   refrain   any   other
person to sell any Partner Products to the particular End User.

7.3. You further acknowledge and understand that: 

(a) The   provision   of   Services   on   the   App   may   be   interrupted,   including   for   maintenance,
repairs, upgrades, or network or equipment failures. Vistas strives to keep the App up
and running; however, all online services suffer occasional disruptions and outages, and
Vistas isn’t liable for any disruption or loss you may suffer as a result.

(b) Vistas may discontinue some or all of the Services provided on the App, as it may deem
fit, including certain features and the support for certain devices and platforms, at any
time. 

7.4. You   additionally   understand   that   Vistas   may   provide   you   with   certain   instructions/directions   in
relation   to   making   recommendations     and   onboarding   End   Users.   You   agree   to   follow   any
instructions/directions   provided   by   Vistas   whilst   undertaking   such   recommendations,   including
without limitation, usage of such keywords provided to you by Vistas.

7.5. The relationship between the My Teams user and Vistas shall be that of independent contractors.
No   partnership,   joint   venture,   franchise,   or   licensing   agreement   shall   be   created   between   the
Parties by virtue of this EULA. It is also clarified that there does not exist any principal agency or
employer-employee relationship between the Parties hereto. Except as otherwise provided herein
or as may be expressly agreed to by the Parties in writing hereafter, the My Teams user shall not
have the authority (whether express or implied) to bind Vistas or to make, modify or release any
contractual obligations or representations on behalf of Vistas. The My Teams user shall not make
any   representations   with   respect   to   the   Services   being   performed   by   Vistas,   without   the   prior
written consent of Vistas.

8. MY TEAMS USERS’ COVENANTS

8.1. You shall ensure that the recommendations made by you are provided to the End Users by you
on a fully functional Android device (such as a Smartphone or tablet) (“Device”). You shall further
ensure   that   (a)   you   have   high   speed   internet   access   and   such   other   accessories   as   may   be
required to be used by you in connection with the Device, details of which shall be intimated to
you by Vistas; and (b) your Device does not contain any viruses or other harmful software, code
or similar means which could damage, harm, disable or otherwise impact or limit the function and
performance of the Services and/or the App or the Device accessing the App.

8.2. While providing services to an End User, (a) you shall not share your personal, religious and/or
moral views with the End User; and (b) you shall comply with this EULA and Applicable Laws and
shall take utmost care in terms of the services being rendered. 

8.3. While providing services to an End User, you shall not indulge in any commercial activity or sale
of any goods outside the purview of this EULA without the prior written consent of Vistas. 

8.4. While providing services to an End User, you shall not solicit, promote, induce or encourage the
End Users, in any manner, to commit or undertake any activity that may be illegal or in violation of
Applicable Law or that may violate the rights, harm or threaten the safety of the concerned End
User or any other person. 

8.5. You shall provide your services to the End Users in highest ethical and professional standards
and manner that reflect favorably, at all times, on Vistas, the Partner and/or the Partner Products
and the name, goodwill and reputation of Vistas, the Partner and/or the Partner Products.

8.6. You shall avoid deceptive, misleading or unethical practices that are or might be detrimental to
Vistas,   the   Partner   and/or   the   Partner   Products   or   the   public,   including,   but   not   limited   to,
disparagement of App and the Services or any other contract or commit any other violation of
Applicable Laws.

8.7. Except as otherwise indicated in this EULA, the My Teams user shall not use/copy or reverse
engineer, trademarks, softwares, service marks, any tagline, any text, photos, pictures, images,
brand logo, labels, trade dressing, product, services, operation, business and customers, or the
App, or the Partner and/or the Partner Product in any manner whatsoever. 

8.8. You shall, at all times, acknowledge Vistas as the owner of the App, and the Partner as the owner
of the Partner Product and of any intellectual property rights in relation thereto respectively, and
shall at no point represent yourself as the owner of the App or any intellectual property rights in
the App. 

8.9. You shall not be permitted to involve any subcontractors to perform the Services, without the prior
written   approval   of   Vistas.   Provided   however   that   if   a   subcontractor   is   appointed   by   you   in
accordance with the terms hereof, you shall at all times, be responsible for the acts, omissions,
defaults and/or negligence of the subcontractor and all agents of them as if they were the acts or
omissions of yours under the terms of this EULA.

8.10. You   shall   treat   all   End   User   Information   provided   by   the   End   Users,   including,   Personal
Information,   if   any,   in   your   possession   with   utmost   confidentiality   and   that   you   will   not   use   or
disclose any such End User Information for your personal use or benefit or benefit of any other
person.   You   acknowledge   and   understand   that   you   are   not   entitled   to   disclose   any   Personal
Information of an End User for any reason whatsoever.  The obligations of the My Teams user
under this clause shall survive in perpetuity.

8.11. You shall not, both during and after the subsistence of this EULA, publish any oral or written
statements   about   Vistas   and/or   the   Partners   or   the   shareholders,   subsidiaries,   affiliates,   and
group companies or each of their respective board of trustees, equity holders, representatives of
Vistas and/or the Partners that: (a) are slanderous, libelous or defamatory; or (b) place any of the
foregoing in false light before the public.

8.12. You shall not make any representation or give any warranty (including by omission) or furnish any
details with respect to specifications, features, fitness for purpose or functionality of the Partner
Products, other than those indicated by the Partner and/or Vistas in writing. 

8.13. You shall ensure that the End User is made aware of the End User Information to be collected
from the End User, and that the information is shared and stored by Vistas and/or the Partner and
the manner in which Vistas and/or the Partner makes use of the End User Information, and shall
be responsible for obtaining explicit consent from the End User for such collection, storage and
use of the End User Information. You agree to indemnify and hold harmless Vistas, its affiliates,
and   their   respective   officers,   directors,   agents,   and   employees,   from   any   and   all   claims   or
demands,   or   actions   including   reasonable   attorneys'   fees,   made   by   any   third   party   or   penalty
imposed due to or arising out of your breach of this clause. 

8.14. You agree that Vistas shall be entitled to revoke, cancel, and expire your access to the App if it
comes to our notice that you are in violation of any of this EULA. 

8.15. You hereby appoint Vistas Technolabs Private Limited, having its registered office at 1105, Rawal
Ji Ka Bazar, Near Hotel Sun City, Ganga Pol, Jaipur, Rajasthan – 302002, India, as your lawful
agent to receive your credit report/credit history (“Credit Information”) from Credit Information
Companies (“CICs”) as notified by Reserve Bank of India.

8.16. You further authorize Vistas to share with CICs, your personal information/details to procure your
Credit   Information   on   a   monthly   frequency   and   use   the   same   to   provide   you   with   service   of
offering financial products suited to your needs (“Purpose”).

8.17. You   understand   and   acknowledge   that   the CIC shall   not   be   liable   under   law   or   equity,   in   any
manner whatsoever, for providing your Credit Information to Vistas and you will not raise any
claim or objections against the CIC. You confirm that this consent is given by your free will and
not due to any solicitation by any person/entity.

8.18. This consent/authorization shall be valid for (i) a maximum period of 06 (six) months, from the
date of giving the same, (ii) satisfying the Purpose or (iii) until you withdraw your consent at any
time, by informing the same to Vistas, at their registered office address, website, assigned email
id or mobile application, whichever is earlier. You also provide consent to the `}
          {/* {!params?.isExperian ? (
            <>
              {params?.isCustomerFlow ? (
                <SH2
                  onPress={navigateToCrif}
                  style={{
                    color: colors.primary[100],
                    textDecorationLine: 'underline',
                  }}
                >
                  terms of use of CRIF High Mark Credit Score
                </SH2>
              ) : (
                'terms of use of CRIF High Mark Credit Score'
              )}
              {', '}
              Experian PLC
            </>
          ) : ( */}
          <>
            terms of use of CRIF High Mark Credit Score,{' '}
            <SH2
              onPress={navigateToExperian}
              style={{
                color: colors.primary[100],
                textDecorationLine: 'underline',
              }}
            >
              Experian PLC
            </SH2>
          </>
          {/* )} */}
          {`  Equifax   Inc.  and   TransUnion   CIBIL   Limited,   as
amended/updated from time to time.

9. CONSIDERATION 

9.1. In  lieu  of  the  services  performed  by  you  as  a  My  Teams  user  in  accordance  with  this  EULA,
Vistas shall be liable to pay such fees and on such rates (“My Teams user Fees”) as may be
calculated by Vistas in relation to inter alia the Partner Product recommendations made by you to
the End Users, and the number of End Users that sign up for the Partner Products as a result of
your recommendation. and duly intimated to you (in a manner deemed fit by Vistas), upon the
receipt of the same from the Partner. The decision of Vistas on whether My Teams user Fees is
payable on a transaction shall be final.

9.2. Payment of such My Teams user Fees shall be made by Vistas on or before the last day of each
calendar month for the previous calendar month in your bank account, or any other mode as may
be adopted by Vistas or within such other time frame as may be intimated to you by Vistas from
time to time. 

10. AGREEMENT TO RECEIVE COMMUNICATION

You hereby by way of accepting this EULA consent to the receipt of communication from Vistas
by   way   of   in   app   messages,   Short   Message   Service   (SMS)   messages,   e-mails,   promotional,
marketing calls and newsletters. These emails could relate to your registration, transactions that
you   carry   out   through   the   App   and   promotions   that   are   undertaken   by   Vistas,   Services   from
Vistas and its third-party partners, as applicable.

11. LINKS TO THIRD PARTY WEBSITES

The   App   may   contain   links   and   interactive   functionality   interacting   with   the   websites   of   third
parties. Vistas is not responsible for and has no liability for the functionality, actions, inactions,
privacy settings, privacy policies, terms, or content of any such websites. Before enabling any
sharing functions to communicate with any such website or otherwise visiting any such website,
Vistas strongly recommends that you review and understand the terms and conditions, privacy
policies, settings, and information-sharing functions of each such third-party website.

12. USE OF THE APP

12.1. You agree, undertake and covenant that, during the use of the App, you shall not host, display,
upload, modify, publish, transmit, store, update or share any information that:

(c) belongs to another person and to which you do not have any right, except as expressly
provided in this EULA.

(d) is   grossly   harmful,   harassing,   blasphemous,   defamatory,   obscene,   pornographic,
pedophilic, libelous, invasive of another person's privacy, insulting or harassing on the
basis   of   gender,   hateful   or   racially   or   ethnically   objectionable,   relating   or   encouraging
money laundering or gambling or an online game that causes harm, or promoting enmity
between   different   groups   on   the   grounds   of   religion   or   caste   with   the   intent   to   incite
violence,   or   otherwise   inconsistent   or   contrary   to   the   applicable   laws   in   force   in   any
manner whatsoever.

(e) is misleading in any way.

(f) is harmful to minors.

(g) involves  the  transmission  of  "junk  mail",  "chain  letters",  or  unsolicited  mass  mailing  or
"spamming".

(h) infringes upon or violates any third party's rights including, but not limited to, any patent,
trademark,   copyright   or   other   proprietary   rights   or   intellectual   property   rights,   rights   of
privacy  (including  without  limitation  unauthorized  disclosure  of  a  person's  name,  email
address, physical address, or phone number).

(i) provides   instructional   information   about   illegal   activities   such   as   violating   someone's
privacy, or providing or creating computer viruses.

(j) tries to gain unauthorized access or exceeds the scope of authorized access to the App
or to profiles, communities, Account information, bulletins, or other areas of the App or
solicits   passwords   or   personally   identifying   information   for   commercial   or   unlawful
purposes from other users of the App.

(k) engages in commercial activities without Vistas prior written consent such as engages in
contests, sweepstakes, barter, advertising etc.

(l) interferes with another person’s use of the App.

(m) impersonates another person.

(n) threatens the unity, integrity, defence, security or sovereignty of India, friendly relations
with   foreign   States,   or   public   order,   or   causes   incitement   to   the   commission   of   any
cognizable   offence   or   prevents   investigation   of   any   offence   or   is   insulting   any   foreign
States.

(o) refers   to   any   website   or   URL   that,   in   Vistas   sole   discretion,   contains   material   that   is
inappropriate for the App or any other website, contains content that would be prohibited
or violates the letter or spirit of this EULA.

(p) deceives or misleads the addressee/ users about the origin of the messages or knowingly
and intentionally communicates any information which is patently false or misleading or
grossly offensive or menacing in nature but may reasonably be perceived as a fact.

(q) is patently false and untrue, and is written or published in any form, with the intent to
mislead or harass a person, entity, or agency for financial gain or to cause any injury to
any person.

(r) contains software viruses or any other computer codes, files or programs designed to
interrupt,   destroy,   or   limit   the   functionality   of   any   computer   resource;   or   contains   any
trojan   horses,   worms   or   other   computer   programming   routines   that   may   damage,
detrimentally interfere with, diminish value of, covertly intercept or steal any system, data
or personal information.

(s) is in the nature of an online game that is not verified as a permissible online game.

(t) is in the nature of advertisement or surrogate advertisement or promotion of an online
game that is not a permissible online game, or of any online gaming intermediary offering
such an online game.

(u) violates any applicable law for the time being in force.

12.2. You hereby accept full responsibility for any consequences that may arise from your use of the
App, and expressly agree and acknowledge than in no event and under no circumstances shall
Vistas be held liable to you for any liabilities or damages resulting from or arising out of your use
of the App. You shall not use anyone else’s Account at any time.

12.3. You agree and acknowledge that you shall not use the App for any fraudulent, malicious, illegal,
or unauthorized purpose/activities. You agree to comply with all applicable laws pertaining to your
use of the App. You further agree and acknowledge that you shall use the Services provided on
the App only for your personal use and not for business purposes.

12.4. Vistas shall have the right, but not the obligation, to monitor your access to or use of the App to
ensure your compliance with this EULA or applicable laws, at its sole discretion. 

13. USERS’ POSTS AND REVIEWS

13.1. The App may allow you to post certain content, data or information belonging to you, such as
reviewing   and   allowing   you   to   share   your   experience   and   views   about   a   particular   product/
service,   and   rate   product/   service,   post   your   comments   and   reviews   in   relation   to   the
product/service on the App on specific pages of the App, as well as submit/post any suggestions,
comments, questions or other information to Vistas using the App (collectively referred to “User
Content”). 

13.2. You,   being   the   originator   of   the   User   Content,   are   responsible   for   the   User   Content   that   you
upload,   post,   publish,   transmit   or   otherwise   make   available   on   the   App.   You   represent   and
covenant that you have obtained all relevant consents and approvals in order to post any User
Content and shall not post any content relating to or owned by a third party for the promotion or
sale of products/ services of such third party. You further represent that all such User Content will
be in accordance with applicable laws. You acknowledge that Vistas does not endorse any User
Content on the App and is not responsible or liable for any User Content. Vistas reserves the right
to remove any third-party marketing material and disable access to the User Content on the App.

13.3. You hereby grant Vistas a perpetual, non-revocable, worldwide, royalty-free, and sub-licensable
right and license to use, copy, distribute, display, publish, transmit, make available, reproduce,
modify, adapt the User Content and create derivative works of the User Content. You represent
and warrant that you own or otherwise control all of the rights to the User Content that you post or
that you otherwise provide on or through the App; and that, as at the date that the User Content is
posted or submitted on the App: (i) the User Content is accurate; (ii) use of the User Content you
supply does not breach this EULA; and (iii) that such User Content is lawful.

13.4. You further represent and warrant that while posting any User Content on the App you shall not
use any offensive, libelous, derogatory, hateful, or racially or ethnically objectionable language.
Further, you shall not post any content on the App that is obscene, pornographic, constitutes an
“indecent   representation   of   women”   as   provided   in   The   Indecent   Representation   of   Women
(Prohibition) Act, 1986.

14. CONTENT AND INTELLECTUAL PROPERTY RIGHTS

14.1. Except   for   User   Content,   all   of   the   content   and   services   and   products   provided   on   the   App,
including   text,   software,   scripts,   code,   designs,   graphics,   photos   and   other   content   and   the
copyrights, trademarks, service marks, logos, trade names, and other intellectual and proprietary
rights associated therewith (“IP”) is owned by Vistas or others (including without limitation, the
third   party   service   providers)   that   Vistas   licenses   such   content   from,   and   is   protected   by
copyright, trademark, patent and other intellectual property laws.

14.2. You   hereby   acknowledge   that   the   IP   constitutes   original   works   and   has   been   developed,
compiled, prepared, revised, selected, and arranged by Vistas and others through the application
of   methods   and   standards   of   judgment   developed   and   applied   through   the   expenditure   of
substantial time, effort, and money and constitutes valuable intellectual property of Vistas and
such others. You thereby agree to protect the proprietary rights of Vistas during and after the term
of   this   EULA.   You   may   not   selectively   download   portions   of   the   App   without   retaining   the
copyright notices. You may download material from the App only for your own personal use and
for no commercial purposes whatsoever.

14.3. You shall use the App strictly in accordance with this EULA, and shall not, directly or indirectly, (i)
decompile,   disassemble,   reverse   engineer,   or   attempt   to   derive   the   source   code   of,   or   in   any
manner decrypt, the App; (ii) make any modification, adaptation or improvement, enhancement,
translation or derivative work from the App; (iii) violate any applicable laws, rules or regulations in
connection with your access or use of the App, including your use of any Content; (iv) remove or
obscure any proprietary notice (including any notices of copyright or trademark) forming a part of
the App; (v) use the App for any commercial or revenue generation endeavors, or other purposes
for which it is not designed or intended; (vi) distribute or transmit the App or other services; (vii)
use the App for data mining, scraping, crawling, redirecting, or for any purpose not in accordance
with this EULA; (ix) use the App for creating a service or software that is directly or indirectly,
competitive   with   the   App   or   any   services   offered   by   Vistas;   or   (x)   derive   any   confidential
information, processes, data or algorithms from the App. 

14.4. Any infringement shall lead to appropriate legal proceedings against you at an appropriate forum
for seeking all available remedies under applicable laws of the country.

15. TERMINATION OF ACCESS TO APP OR DEACTIVATION OF SERVICE 

15.1. Your Account can be terminated/deactivated at any time by: 

(a) You, by requesting for such termination/deactivation of your Account on the App. 

(b) Vistas, in its sole discretion for any reason or no reason, including your violation of this
EULA or lack of use of App. You acknowledge that the termination of access to the App
may   be   affected   without   any   prior   notice,   and   Vistas   may   immediately   deactivate   or
delete   the   Account   and   all   related   information   and/or   bar   any   further   access   to   the
Account or the services provided on the App, subject to applicable law.  

15.2. Upon termination of this EULA, the My Teams user shall forthwith return and/or destroy all End
User Information to the relevant End User within a period of 15 (Fifteen) days from the date of
such termination of the Account.

15.3. Any compensation pending against your services post termination will be made by Vistas in the
following month in accordance with the terms of this EULA. 

15.4. The   disclaimer   of   warranties,   the   limitation   of   liability,   and   the   governing   law   provisions   shall
survive any termination of this EULA.

16. REFERRALS AND REWARDS
From time to time, Vistas may offer referral bonuses and rewards to you for inviting new users to
the App and for completing other activities as per the terms and conditions indicated by Vistas to
you.

17. RIGHTS & RESERVATIONS

17.1. Vistas reserves the right to: 

(a) Make all decisions in relation to inter aliayour registration with Vistas;

(b) Request   additional   documents   and   additional   information   from   you   for   the   purpose   of
your registration as a user on the App; and

(c) Deny access to the App or any portion thereof without notice for the following reasons (i)
any unauthorized access or use by you; (ii) attempt(s) to assign or transfer any rights
granted to you under this EULA; and (iii) violation of any of the provisions of the EULA or
any applicable laws.

18. REPRESENTATIONS 

18.1. You hereby represent and warrant that you have validly entered into this EULA and have the
legal power to do so. You further represent and warrant that you (a) shall be solely responsible
for the due compliance with this EULA; (b) have the requisite expertise for providing services on
the App; and (c) are not part of any arrangement which would prohibit you from providing such
services. 

18.2. While Vistas makes reasonable enquiries to confirm the veracity of these representations made
to Vistas by you, Vistas shall not be responsible for any misrepresentation or fraud in this regard.
Neither does Vistas recommend, nor does Vistas endorse you or make any representations or
warranties with respect to quality of the services provided by you via. the App

19. DISCLAIMER OF WARRANTIES

THE APP AND ALL INFORMATION, CONTENT, MATERIALS AND SERVICES INCLUDED ON
OR   OTHERWISE   MADE   AVAILABLE   TO   YOU   THROUGH   THE   APP   (COLLECTIVELY,   THE
"MATERIALS")   ARE   PROVIDED   BY   VISTAS   ON   AN   "AS   IS,"   "AS   AVAILABLE"   BASIS,
WITHOUT   REPRESENTATIONS   OR   WARRANTIES   OF   ANY   KIND.   VISTAS   MAKES   NO
REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE
OPERATION OF THE APP, THE ACCURACY OR COMPLETENESS OF THE MATERIALS AND
THE ACCURACY OF THE INFORMATION. NO ADVICE OR INFORMATION, WHETHER ORAL
OR WRITTEN, OBTAINED BY YOU FROM VISTAS OR THROUGH OR FROM THE APP OR
CONTENT SHALL CREATE ANY WARRANTY. VISTAS SHALL HAVE NO RESPONSIBILITY
FOR ANY DAMAGE TO YOUR DEVICES OR LOSS OF DATA THAT RESULTS FROM THE
DOWNLOAD   OF   ANY   CONTENT,   MATERIALS,   DOCUMENT,   OR   INFORMATION.   YOU
EXPRESSLY AGREE THAT THE USE OF THE APP IS AT YOUR SOLE RISK. VISTAS WILL
NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE APP
OR   THE   MATERIALS   INCLUDING,   WITHOUT   LIMITATION,   DIRECT,   INDIRECT,
CONSEQUENTIAL,   PUNITIVE,   AND   CONSEQUENTIAL   DAMAGES,   UNLESS   OTHERWISE
SPECIFIED IN WRITING. TO THE FULL EXTENT PERMITTED BY LAW, VISTAS DISCLAIMS
ANY AND ALL REPRESENTATIONS AND WARRANTIES WITH RESPECT TO THE APP AND
ITS   MATERIALS,   WHETHER   EXPRESS   OR   IMPLIED,   INCLUDING,   WITHOUT   LIMITATION,
WARRANTIES   OF   TITLE,   MERCHANTABILITY,   AND   FITNESS   FOR   A   PARTICULAR
PURPOSE OR USE.

20. LIMITATION OF LIABILITY

20.1. In   no   event   shall   Vistas,   its   affiliates   and   group   companies   (as   applicable)   and   each   of   their
respective   officers,   directors,   employees   and   agents  (as   applicable)   be   liable   to   you   for   any
special,   incidental,   indirect,   consequential,   exemplary   or   punitive   damages,   or   loss   of   profit   or
revenues whatsoever resulting from any (a) errors, mistakes, or inaccuracies of content; (b) any
unauthorized access to or use of the secure servers and/or any and all personal and/or other user
information stored therein; (c) any interruption or cessation of transmission to or from the services
on the App  or the failure of the Services to remain operational for any period of time; (d) any
bugs, viruses, trojan horses, or the like, which may be transmitted to or through the App by any
third party; (e)  any  loss of your data arising from any use of or inability to use any Content or
other parts of the App;  (f)  your failure to keep Login Credentials or Account details secure and
confidential;  (g)   non-availability   of   the   Services   in   certain   geographical   areas;  and/or   (h)   any
errors or omissions in any content or for any loss or damage of any kind incurred as a result of
the use of any content posted, emailed, transmitted, or otherwise made available via the App,
whether based on warranty, contract, tort, or any other legal theory, and whether or not  Vistas is
advised of the possibility of such damages. Vistas shall not be liable under any circumstance for
damages arising out of or in any way related to Services and/or information provided by third
parties through the App.

21. INDEMNIFICATION

You shall indemnify and hold harmless Vistas, its affiliates, and their respective officers, directors,
agents,  and  employees,  from  any  and  all  claims  or  demands,  or  actions  including  reasonable
attorneys' fees, made by any third party or penalty imposed due to or arising out of your breach of
this EULA, Policy and other policies, or your violation of any law, rules or regulations or the rights
(including infringement of any intellectual property rights) of a third party.

22. PRIVACY POLICY

Please review the Policy, which also governs your visit to the App, to understand Vistas privacy
practices. The Personal Information provided to Vistas by you during the course of usage of the
App will be treated as strictly confidential and in accordance with the Policy and applicable laws
and regulations. If you object to your Personal Information being transferred or used, please do
not use the App.

23. ASSIGNMENT

You shall not license, sell, transfer, or assign your rights, obligations, or covenants under this
EULA in any manner without Vistas prior written consent. Vistas reserves the right, at its own
discretion, to freely assign and transfer the rights and obligations under this EULA to any third
party.

24. GOVERNING LAW AND DISPUTE RESOLUTION

This EULA shall be governed by and interpreted and construed in accordance with the laws of
India. The place of jurisdiction shall exclusively be in Bangalore, Karnataka. In the event of any
dispute arising out of this EULA the same shall be settled by a binding arbitration conducted by a
sole arbitrator, appointed jointly by both parties and governed by the Arbitration and Conciliation
Act, 1996. The venue and seat of arbitration shall be Bangalore, Karnataka.

25. SEVERABILITY AND WAIVER 

This   EULA,   the   Policy   and   other   referenced   material   herein   or   on   the   App,   are   the   entire
agreement between you and Vistas with respect to the products/Services offered on the App and
supersede all prior or contemporaneous communications and proposals (whether oral, written or
electronic) between you and Vistas with respect thereto and govern your future relationship with
Vistas. If any provision of the EULA is found to be unenforceable or invalid, that provision will be
limited or eliminated to the minimum extent necessary so that the EULA will otherwise remain in
full force and effect and enforceable. The failure of either party to exercise in any respect any
right provided for herein shall not be deemed a waiver of any further rights hereunder.

26. GRIEVANCE REDRESSAL MECHANISM

26.1. In accordance with the Information Technology Act, 2000 and Rules made thereunder, the name
and contact details of the Grievance Officer are provided below: 
Name: Mohan Singhal
Email: hi@   myteams.co.in    
Phone No: 7417274072

26.2. For   registering   your   complaint,   please   write   to   the   Grievance   Officer   at   the   above-mentioned
email   address   in   relation   to   any   violation   of   this   EULA   or   the   Information   Technology
(Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021. The Grievance Officer shall
redress the complaint in accordance with the provisions of the Information Technology Act, 2000
and Rules made thereunder.

27. HOW TO CONTACT US

If you have questions or concerns about this EULA, please contact Vistas at the following email
address: hi@myteams.co.in 
        `}
        </SH2>
      </ScrollView>
    </Stack>
  )
}

export default TermsOfUse
